import { render, staticRenderFns } from "./UserReviewList.vue?vue&type=template&id=229f1a4e&"
import script from "./UserReviewList.vue?vue&type=script&lang=ts&"
export * from "./UserReviewList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports